import { useEffect } from 'react'
import { useResetOnChange } from './useResetOnChange'

const SUPPRESS_MS = 1000

// True for a beat after `open` flips true. Dialogs opened by a long-press
// inherit the gesture: the browser resolves the still-held press into a text
// selection or an iOS touch-callout over whatever the dialog painted under the
// finger. Suppressing selection for the first second swallows that without
// making the content permanently unselectable.
export function useSuppressSelectionOnOpen(open: boolean): boolean {
  const [suppressed, setSuppressed] = useResetOnChange(open, () => open)

  useEffect(() => {
    if (!open) return
    const t = setTimeout(() => setSuppressed(false), SUPPRESS_MS)
    return () => clearTimeout(t)
  }, [open, setSuppressed])

  return suppressed
}
